// extracted by mini-css-extract-plugin
export var backgroundOff = "header-module--backgroundOff--AaLDa";
export var header = "header-module--header--Zms1V";
export var logo = "header-module--logo--mTLiM";
export var logoWrapper = "header-module--logoWrapper--i2C1d";
export var nav = "header-module--nav--e8OJ3";
export var wrapper = "header-module--wrapper--uoQUP";